module.exports = __webpack_public_path__ + "static/img/s_6.1a855d93.png";